import React, { useContext, useEffect } from "react";
import { AuthContext } from "./contexts/AuthContext";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const { isAuth, isLoading } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={routeProps => {
        if (isLoading) return null;
        return isAuth === true
          ? <RouteComponent {...routeProps} />
          : <Redirect to={"/Login"} />;
      }}
    />
  );
};


export default PrivateRoute
